import { render, staticRenderFns } from "./SolicitacoesReaberturas.vue?vue&type=template&id=355b2091"
import script from "./SolicitacoesReaberturas.vue?vue&type=script&lang=js"
export * from "./SolicitacoesReaberturas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports